let subscribers = (typeof window !== "undefined" && window._subscribers) || {};
if (typeof window !== "undefined") {
  window._subscribers = subscribers;
}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      try {
        callback(data);
      } catch (e) {
        console.error(e);
      }
    });
  }
}

if (typeof window !== "undefined") {
  window.subscribe = window.subscribe || subscribe;
  window.publish = window.publish || publish;
}
